import { ApiCoupon } from '@/models/api/coupon'
import _ from 'lodash'
import { GetterTree } from 'vuex'
import { RootState } from '../../types'
import { CouponState } from './types'

export const getters: GetterTree<CouponState, RootState> = {
  // If only available coupons are loaded, this filtering may have partly a duplicate effect.
  availableCoupons(state): ApiCoupon[] {
    return _.filter(state.coupons, (coupon: ApiCoupon) => coupon.isAvailable)
  },
  allCoupons(state): ApiCoupon[] {
    return state.coupons
  },
  // クーポンコード付き以外の利用可能なクーポンを取得.
  availableCouponsWithoutCouponCode(state): ApiCoupon[] {
    return _.filter(state.coupons, (coupon: ApiCoupon) => coupon.isAvailable && !coupon.hasCouponCode)
  },
  // 入力中のクーポンコードテキストを取得
  couponCodeInputted(state): string {
    return state.couponCode.inputtingText
  },
}
